import { cacheable } from 'utils'
import { FETCH_AGES, FETCH_REGISTRY } from './types'
import { CONTENT } from 'common/endpoints'
import { REGISTRIES } from 'common/constants'

const fetchAges = cacheable(
  s => s.registry.ages.length,
  FETCH_AGES,
  () => ({ meta: { url: CONTENT.AGES } })
)

export const fetchBasicRegistry = (ids = Object.values(REGISTRIES)) => ({
  type: FETCH_REGISTRY,
  meta: { url: `${CONTENT.REGISTRY}?ids=${ids}` },
})

export const fetchRegistry = (ids = Object.values(REGISTRIES)) => dispatch => {
  ids.includes(REGISTRIES.AGE) && dispatch(fetchAges())
  dispatch(fetchBasicRegistry(ids))
}
